// src/pages/ResetPasswordPage.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function ResetPasswordPage() {
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const { token } = useParams(); // Obtiene el token de la URL
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://kifli-api.onrender.com/api/reset-password/${token}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ newPassword }),
            });
            const data = await response.json();
            setMessage(data.message);
            if (response.ok) {
                setTimeout(() => navigate('/ingresar'), 2000); // Redirige al login después de 2 seg
            }
        } catch (error) {
            setMessage('Error de conexión.');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="max-w-md w-full space-y-8 bg-[#292929] p-10 rounded-xl">
                <h2 className="text-center text-3xl font-bold text-white">Nueva Contraseña</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required minLength="6" className="input-field" placeholder="Ingresa tu nueva contraseña" />
                    <button type="submit" className="form-button bg-lime-400 text-black">Actualizar Contraseña</button>
                </form>
                {message && <p className="text-center text-white mt-4">{message}</p>}
            </div>
        </div>
    );
}
export default ResetPasswordPage;